import { PublicationState } from 'generated/graphql'

export const publicationState = (preview: boolean): PublicationState =>
    preview ? PublicationState.Preview : PublicationState.Live